/* eslint-disable  */
// eslint-disable-next-line no-use-before-define
import React from 'react';
import { CarePlanAction, DEFAULT_CAREPLAN_STATE } from './Interface';

// Local workflow/reducer context for imperative actions and transient UI state in the careplan shell.
// This remains separate from the GraphQL-backed CareplanDataContext which provides server data and selectors.
const ROPatientCarePlanContext = React.createContext({
  state: DEFAULT_CAREPLAN_STATE,
  dispatch: (_action: CarePlanAction): void => {},
});
export default ROPatientCarePlanContext;
